'use client';

import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useTranslations } from 'use-intl';

// In the native shell the webview runs edge-to-edge, so Sonner's default
// offsets put top toasts under the status bar, where iOS swallows taps on the
// close button. env(safe-area-inset-*) is 0 on the web, so nothing moves there.
const SAFE_OFFSET: ToasterProps['offset'] = {
  top: 'calc(env(safe-area-inset-top) + 24px)',
  bottom: 'calc(env(safe-area-inset-bottom) + 24px)',
};
const SAFE_MOBILE_OFFSET: ToasterProps['mobileOffset'] = {
  top: 'calc(env(safe-area-inset-top) + 16px)',
  bottom: 'calc(env(safe-area-inset-bottom) + 16px)',
};

export function Toaster({ toastOptions, ...props }: ToasterProps) {
  const { theme = 'system' } = useTheme();
  // Sonner names the close button "Close toast" in English everywhere.
  const t = useTranslations('common.actions');

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      offset={SAFE_OFFSET}
      mobileOffset={SAFE_MOBILE_OFFSET}
      toastOptions={{ closeButtonAriaLabel: t('close'), ...toastOptions }}
      {...props}
    />
  );
}
